import axios from "axios";
import { getUserToken } from "../function/AuthStorage";
import { domain } from "../util/Apiconfig";
import { announceDataChange, isMutation } from "./dataChanges";
import { announceWorkOrderRuleError, announceWorkOrderRuleResponse } from "../util/workOrderNumberRule";
import {
  attachContractHeader,
  readStoredContractId,
  setActiveContractId,
} from "./activeContract";

const axiosInstance = axios.create({
  baseURL: `${domain}/api/`,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = getUserToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // تحديث 88: لغة المستخدم للخادم (رسائل وتقارير وملفات PDF/Excel المولدة)
    try { config.headers["Accept-Language"] = localStorage.getItem("app-language") === "en" ? "en" : "ar"; } catch { /* */ }
    return config;
  },
  (error) => Promise.reject(error)
);

/*
  ترويسة العقد النشط.

  تُلحق بالمثيل المشترك وبـ axios العام معاً: مثيلات axios.create لا ترث
  مُعترِضات المثيل الافتراضي، وأكثر من خمسين ملفاً هنا ينادي axios مباشرة.
*/
attachContractHeader(axiosInstance);
attachContractHeader(axios);

// الملفات القديمة التي تنادي axios مباشرة (إنشاء/تعديل/حذف) تُعلن التغيير أيضاً
axios.interceptors.response.use(
  (response) => {
    if (isMutation(response.config)) announceDataChange(response.config.url);
    // قاعدة رقم/رمز أمر العمل: القبول للمرة الثانية برمز مختلف ← Toast نجاح
    announceWorkOrderRuleResponse(response);
    return response;
  },
  (error) => {
    // رفض قاعدة رقم/رمز أمر العمل ← Toast صغيرة (الشاشات القديمة)
    announceWorkOrderRuleError(error);
    return Promise.reject(error);
  }
);

// المحفوظ يُقرأ مرّة عند الإقلاع، فأوّل طلب بعد إعادة التحميل يحمل العقد
// نفسه — وإلا عادت الصفحة إلى عقد آخر لحظةً قبل أن يصحّحها المزوّد.
setActiveContractId(readStoredContractId());

axiosInstance.interceptors.response.use(
  (response) => {
    // تعديل ناجح: كل الشاشات المفتوحة تعيد جلب بياناتها
    if (isMutation(response.config)) announceDataChange(response.config.url);
    announceWorkOrderRuleResponse(response);
    return response;
  },
  (error) => {
    announceWorkOrderRuleError(error);
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("user");
      if (window.location.pathname !== "/") {
        window.location.href = "/";
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;